exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ld-infos .column {\n  padding-bottom: 0 !important;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!./app/components/user/user.component.css
// module id = 870
// module chunks = 0